import {
  Button,
  Alert,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";

import { Link, useNavigate } from "react-router-dom";
import AppSpinner from "../../elements/AppSpinner";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import API from "../../api/api/API";
import AuthFooter from "../../components/Footers/AuthFooter";
import { useState } from "react";
import AdminNavbar from "../../components/Navbars/IndexNavbar";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");

  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  function sendEmail(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setSubmitting(true);
    setError("");

    API.sendForgotPasswordEmail(email, window.location.origin)
      .then(
        () => {
          console.log("Success!");
          setSuccess(true);
        },
        (error) => {
          if (error.response && error.response.status === 404) {
            setError(
              "We could not find an account with the email you provided."
            );
          } else {
            setError(
              "We're having trouble sending your password reset email. Please try again."
            );
          }
        }
      )
      .finally(() => {
        setSubmitting(false);
      });
  }

  return (
    <>
      <AppHelmet title="Forgot Password - GrowthCloud.com" />
      <div className="main-content">
        <AdminNavbar bg="" />

        <Container
          fluid
          className="pb-5"
          style={{ height: "calc(100vh - 125px - 3rem)" }}
        >
          <div
            style={{
              width: "100%",
              minHeight: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                flexGrow: 1,
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Row className="justify-content-center mt-4 mt-sm-6">
                <Col lg="6" xl="5" md="8">
                  <div>
                    {success ? (
                      <>
                        <h2 className="text-dark mb-4 mt-5">
                          Password Recovery
                        </h2>
                        <div
                          className="mt-0 font-weight-500 text-dark mb-4"
                          style={{ fontSize: 15 }}
                        >
                          If we found a user with email &nbsp;
                          <span className="font-weight-bold">{email}</span>, you
                          will receive an email from us shortly.
                        </div>
                        <div
                          className="mt-0 font-weight-500 text-dark mb-4"
                          style={{ fontSize: 15 }}
                        >
                          If you do not receive the email within a few minutes,
                          please check your junk/spam email folder
                        </div>
                        <Button
                          className="px-4"
                          color="primary"
                          type="submit"
                          onClick={() => {
                            navigate("/login", { replace: true });
                          }}
                        >
                          Return to sign in
                        </Button>
                      </>
                    ) : (
                      <>
                        <h2 className="text-dark mb-4 mt-5">
                          Reset your GrowthCloud password
                        </h2>
                        <div
                          className="mt-0 font-weight-500 text-dark mb-4"
                          style={{ fontSize: 15 }}
                        >
                          Enter your email below and we'll send you a link to
                          reset your password.
                        </div>
                        <div
                          className="mt-0 font-weight-500 text-dark mb-4"
                          style={{ fontSize: 15 }}
                        >
                          Remember your password?
                          <Link className="text-primary ml-2" to="/login">
                            Return to sign in
                          </Link>
                        </div>
                        <Form role="form" onSubmit={sendEmail}>
                          <FormGroup>
                            <h5 className="text-dark">Email</h5>
                            <Input
                              placeholder="Email"
                              type="email"
                              name="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required={true}
                            />
                          </FormGroup>

                          <div className="text-left">
                            <Button
                              disabled={submitting || !email}
                              className="mb-4 px-4"
                              color="primary"
                              type="submit"
                            >
                              {submitting ? (
                                <span className="px-4">
                                  <AppSpinner
                                    style={{ height: 20, width: 20 }}
                                    color="white"
                                  />
                                </span>
                              ) : (
                                <>Reset Password</>
                              )}
                            </Button>
                          </div>
                          {error ? (
                            <Alert color="warning">{error}</Alert>
                          ) : null}
                        </Form>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="mt-5">
            <AuthFooter />
          </div>
        </Container>
      </div>
    </>
  );
};

export default ForgotPassword;
